
import { Form, Input, Icon, Button, Row, Col, Select, Divider } from 'antd';
import React from 'react'
let id = 0;
const { Option } = Select;
class EAD extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isloding: false, States: []
    }
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values.keys.length > 0) {
          let names = [];
          let { firM_OR_LAST_NAME, firsT_NAME, middlE_NAME, namE_CODE } = values;
          Object.keys(firM_OR_LAST_NAME).forEach(function (i) {
            names.push({
              firM_OR_LAST_NAME: firM_OR_LAST_NAME[i],
              firsT_NAME: firsT_NAME[i], middlE_NAME: middlE_NAME[i], namE_CODE: namE_CODE[i]
            })
          });
          this.props.submitHandler({ name: names });
        }
        else {
          this.props.submitHandler({ name: [] });
        }
      }
    });
  }
  remove = (k) => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    form.setFieldsValue({
      keys: keys.filter(key => key !== k),
    });
  };
  add = () => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    const nextKeys = keys.concat(id++);
    form.setFieldsValue({
      keys: nextKeys,
    });
  };
  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    let { name } = this.props.niprappoinment;
    getFieldDecorator('keys', { initialValue: this.props.niprappoinment && name ? name.slice(1) : [] });
    const keys = getFieldValue('keys');
    const formItems = keys.map((k, index) => (
      <div key={index}>
        <Row >
          <Col md={12} sm={24}>

            <Form.Item>

              <fieldset className="mi_input_pop">
                <legend className="legend-font">Firm or Last Name *</legend>
                {getFieldDecorator(`firM_OR_LAST_NAME[${k}]`, {
                  initialValue: k.firM_OR_LAST_NAME,
                  rules: [{ required: true, message: 'Please enter Last Name' }, {
                    pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                    message: "Last Name is not valid"
                  }, {
                    max: 100,
                    message: "Last Name is  must be at most 100 characters"
                  }],
                })(<Input autoComplete={"nope"} maxLength={100} className="mi_input" placeholder="Enter Firm or Last Name" />)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={12} sm={24}>
            <Form.Item


            >
              <fieldset className="mi_input_pop">
                <legend className="legend-font">First Name </legend>
                {getFieldDecorator(`firsT_NAME[${k}]`, {
                  initialValue: k.firsT_NAME,
                  rules: [
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "First Name is not valid"
                    }, {
                      max: 25,
                      message: "First Name is  must be at most 25 characters"
                    }
                  ],
                })(<Input autoComplete={"nope"} maxLength={25} className="mi_input" placeholder="Enter First Name " />)}
              </fieldset>
            </Form.Item>
          </Col></Row>
        <Row>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Middle Name</legend>
                {getFieldDecorator(`middlE_NAME[${k}]`, {                  
                  initialValue: k.middlE_NAME,
                  rules: [{
                    pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                    message: "Middle Name is not valid"
                  }, {
                    max: 25,
                    message: "Middle Name is  must be at most 25 characters"
                  }],
                })(<Input autoComplete={"nope"} maxLength={25} className="mi_input" placeholder="Enter Middle Name" />)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Alternative Name Type *</legend>
                {getFieldDecorator(`namE_CODE[${k}]`, {
                  initialValue: k.namE_CODE,
                  rules: [{ required: true, message: 'Please select Alternative Name Type' },],
                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                  optionFilterProp="children"
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.onChange}
                  placeholder="Please Select Alternative Name Type ">
                  <Option value="2" key="1">Alias</Option>
                  <Option value="3" key="2">Doing Business As</Option>
                  <Option value="4" key="3"> Formerly Known As</Option>

                </Select>)}
              </fieldset>
            </Form.Item>

          </Col></Row>
        <Row>
          <Col md={24} sm={24}>
            {keys.length > 0 ? (
              <Button style={{ backgroundColor: "red", color: "white", float: "right", marginRight: "16px" }} onClick={() => this.remove(k)}> <Icon
                className="dynamic-delete-button"
                type="minus-circle-o"
              ></Icon>Remove</Button>
            ) : null}
          </Col> </Row>
        <Divider></Divider> </div>

    ));
    return (
      <Form layout="vertical" hideRequiredMark onSubmit={this.handleSubmit} >
        <Row>
          <Col sm={24}><p style={{ background: '#9982821f', padding: '10px' }} >List any other assumed, fictitious, alias or trade names under which you are currently doing business or intend to do business.</p></Col>
          <Col sm={24}>
            <Row>
              <Col md={24} sm={24}> {formItems}</Col>
              <Col md={24} sm={24}>
                <Button className=" ant-btn-primary" onClick={this.add} style={{ float: "right" }}>
                  <Icon type="plus" /> Add
                </Button>
              </Col>
            </Row>
          </Col></Row>
        <Row>
          <Col md={24}>
            <div className="collapsepanel-footer">
              <Button className=" ant-btn mi_button_right" style={{ float: "left", marginTop: "-20px", marginLeft: "-11px" }} onClick={() => this.props.back("exp")}> Back</Button>
              <Button htmlType='submit' className=" ant-btn-primary" style={{ float: "right", marginTop: "-20px", marginRight: "-11px" }}> Next</Button>
            </div>
          </Col></Row>
      </Form>
    );
  }
}
const NiprAliases = Form.create()(EAD);
export default NiprAliases;